import React from "react";
import { Route, Routes } from "react-router-dom";
import { MemberLibraryPage } from "./MemberLibraryPage";

export const MemberLibraryPageRouter: React.FC = () => {
	return (
		<Routes>
			<Route
				path="/"
				element={<MemberLibraryPage />}
			/>
		</Routes>
	);
};
